import { render } from "./MesRendezVous.vue?vue&type=template&id=b488ce70&scoped=true"
import script from "./MesRendezVous.vue?vue&type=script&lang=js"
export * from "./MesRendezVous.vue?vue&type=script&lang=js"

import "./MesRendezVous.vue?vue&type=style&index=0&id=b488ce70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b488ce70"

export default script